import React, { Component } from 'react'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import request from '../../lib/requester'
import _ from 'lodash'
import ReactExport from "react-export-excel-hot-fix"
import moment from 'moment'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn


class responsibility extends Component {


    constructor(props) {
        super(props);
        
        this.state = {
            dataTable: [],
            baseTable: [],
            progtypeid:'',
            progname:'',
            orgname:'',
            lovPrincipal:[],
            princid:'',
            is_active:'',
            search: '',
            success:'',
            error: '',
            user: JSON.parse(window.localStorage.getItem('is_user'))
        }
    }
    
    componentDidMount = () => {
        let url = '/arman/v1/setup/menu'
        let param = {
            org_id: this.state.user.org_id
        }
        this.setState({ loading: true })
        request.postArman(url, param, {
            success: function(response) {
                let { data } = response.data
                console.log(response.data)
                data.map((item, index) => {
                    item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
                    item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
                    return item
                })
                this.setState({ loading: false, dataTable: data, baseTable: data})
            }.bind(this),
            error: function(e) {
                this.setState({ loading: false })
            }.bind(this)
        })

        this.getPrincipal()
    }

    renderTable = () => {
        const data = {
            columns: [
                {
                    Header: 'ID',
                    accessor: 'menu_id',
                    width: 50,
                },
                {
                    Header: 'PARENT',
                    accessor: 'parent_id',
                    width: 50
                },
                {
                    Header: 'MENU',
                    accessor: 'menu',
                    width: 200
                },
                {
                    Header: 'URL',
                    accessor: 'url_path',
                    width: 600
                },
                {
                    Header: 'Active',
                    accessor: 'active_flag',
                    width: 150,
                    Cell: row => (
                        <div style={{ textAlign:"center"}}>
                            <input type="checkbox" name = {row.accessor}  checked></input>
                        </div>
						
					)
                }
            ],
            rows: this.state.dataTable

        }
        return (<ReactTable
            className="fullWidth"
            data={data.rows}
            columns={data.columns}
            defaultPageSize={10}
        />)
    }

    getPrincipal = () => {
        let url = '/api/traces/v1/general/list-principal'
        request.getTraces(url, {
            success: function (response) {
                this.setState({ lovPrincipal: response.data.data })
            }.bind(this),
            error: function (e) {
                console.log(e)
            }
        })
    }

    handleChangeActive = (event) => {
        let value = event.target.value
        let name = event.target.name

        // this.setState({ activeflag: value })
        window.setTimeout(() => {
            console.log(this.state.activeflag)
        }, 100)
    }

    handleSearch = (e) => {
    let value = e.target.value
    this.setState({ search: value })
    let baseTable = _.filter(this.state.baseTable, function(o) {
        return o.username.toLowerCase().includes(value.toLowerCase())
    })
    this.setState({ dataTable: baseTable })
    }

    goUpdate = (rows) => {
        let { row } = rows
        // this.props.history.push('/admin/setup/user/userupdate/' + row.user_id)

            let url = "/api/traces/v1/setup/updateprogram"
            // let { skbNumber, supplierId, supplier, supplierSite, potongTagihan, pphRate, pphType, dpp, pph, ppn, totalAmount, fileContainer } = this.state
            // let { id } = this.props.match.params
            let param = {
                id: row.org_id,
                name: row.org_name, 
                userid : JSON.parse(window.localStorage.getItem('is_user')).user_id
            }

            this.setState({ loading: true })
            request.postTraces(url, param, {
                success: function (response) {
                    this.setState({ loading: false, success: response.data.message })

                    window.scrollTo(0, 0)
                    let app = this
                    window.setTimeout(() => {
                        window.location.reload(false);
                        // app.props.history.push('/admin/setup/master/principal')
                        // this.renderTable()
                    }, 2000)
                }.bind(this),
                error: function (e) {
                    window.scrollTo(0, 0)
                    this.setState({ loading: false, error: ['Failed to submit, please try again'] })
                }.bind(this)
            })

    }


    handleChangeValue = (event) => {
        let value = event.target.value
        let valname = event.target.name

        // this.setState({ activeflag: value })

        if (valname === 'insname') {
            this.setState({name: value})
        } 
        else if (valname === 'org_id')
        {
            this.setState({princid: value})
        }
      
        window.setTimeout(() => {
            console.log(valname)
        }, 100)
    }


    handleSave = () => {
        if (this.validateForm()) {
            let url = "/api/traces/v1/setup/insertprogram"
            // let { skbNumber, supplierId, supplier, supplierSite, potongTagihan, pphRate, pphType, dpp, pph, ppn, totalAmount, fileContainer } = this.state
            // let { id } = this.props.match.params
            let param = {
                name: this.state.name, 
                principal: this.state.princid, 
                userid : JSON.parse(window.localStorage.getItem('is_user')).user_id
            }

            this.setState({ loading: true })
            request.postTraces(url, param, {
                success: function (response) {
                    this.setState({ loading: false, success: response.data.message })

                    window.scrollTo(0, 0)
                    let app = this
                    window.setTimeout(() => {
                        window.location.reload(false);
                        // app.props.history.push('/admin/setup/master/principal')
                        // this.renderTable()
                    }, 2000)
                }.bind(this),
                error: function (e) {
                    window.scrollTo(0, 0)
                    this.setState({ loading: false, error: ['Failed to submit, please try again'] })
                }.bind(this)
            })
        }
}

validateForm = () => {
    let count = 0
    let error = []
    this.setState({ error: [], success: '' })
    if (this.state.name  === '') {
        error.push('Name is empty')
        ++count
    } else if (this.state.princid == 0 || this.state.princid == '') {
        error.push('principal is empty')
        ++count
    } 

    if (count > 0) {
        this.setState({ error: error})
        window.scrollTo(0, 0)
        return false
    } else {
        return true
    }
}


showSuccess = () => {
    if (this.state.success.length > 0) {
        return (
            <div className="alert alert-success" role="alert">
                { this.state.success }
            </div>
        )
    }
}
showError = () => {
    if (this.state.error.length > 0) {
        return (
            <div className="alert alert-danger" role="alert">
                <ul>
                    { this.state.error.map((item, index) => {
                        return (<li key={index}>{item}</li>)
                    })}
                </ul>
            </div>
        )
    }
}

    render() {
        return (
            <div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row ml-1">
                            <div className="col-lg-12">
                                <div className="card card-info">
                                    <div className="card-header">List</div>
                                    <div className="card-body">
                                    { this.showSuccess() }
                                    { this.showError() }
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <input type="text" className="form-control" placeholder="Search Principal..." onChange={ this.handleSearch.bind(this) } />
                                            </div>
                                        </div>
                                        <div className="clearfix">&nbsp;</div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                { this.renderTable() }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="clearfix">&nbsp;</div>
                            <div className="col-lg-12">
                                <div className="card card-info">
                                    <div className="card-header">Create New Program Type</div>
                                  
                                    
                                
                                        
                                        
                                        <div className="col-sm-9">
                                                    <button type = "button" className="btn btn-success" onClick={ this.handleSave.bind(this) } >Add</button>&nbsp;
                                                    {/* <button type = "button" className="btn btn-warning" onClick={ this.handleCancel.bind(this) }>Cancel</button> */}
                                            </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }



}
export default responsibility